import React from "react";
import Navbar from "../../common/Navbar/Navbar";
import Main from "./Main";

function Support() {
  return (
    <div>
      <Navbar>
        <Main />
      </Navbar>
    </div>
  );
}

export default Support;
